import React from "react";
import "./Footer.css";
import { footerContent } from "../../data/content";

const Footer = () => {
  return (
    <footer className="footer">
      <p>{footerContent.text}</p>
    </footer>
  );
};

export default Footer;